import { Box, Dropdown } from '@approvalmax/ui/src/components';
import { FC, memo, useCallback, useMemo } from 'react';
import PhoneInput, { Props, Value } from 'react-phone-number-input';
import { amplitudeService } from 'services/amplitude';

import { EmptyComponent, InternationalIcon } from './PhoneField.constants';
import { useDefaultCountry, usePhoneLabels } from './PhoneField.hooks';
import { messages } from './PhoneField.messages';
import {
    ArrowIcon,
    PhoneDropdown,
    PhoneInfoContainer,
    PhoneSection,
    StyledInfoIcon,
    StyledPhoneInputComponent,
} from './PhoneField.styles';
import { PhoneFieldProps } from './PhoneField.types';

const PhoneField: FC<PhoneFieldProps> = memo((props) => {
    const { value, onChange, isPhoneTouched, setIsPhoneTouched, invalid, ...otherProps } = props;

    const defaultCountry = useDefaultCountry();
    const phoneLabels = usePhoneLabels();

    const handlePhoneDropdownOpen = useCallback((open: boolean) => {
        if (open) {
            amplitudeService.sendData('signup: click on tooltip why phone is needed');
        }
    }, []);

    const handleFocus = useCallback(() => {
        setIsPhoneTouched(true);
    }, [setIsPhoneTouched]);

    const countrySelectProps = useMemo(
        () => ({
            arrowComponent: ArrowIcon,
        }),
        []
    );

    return (
        <PhoneSection $hideFlag={!isPhoneTouched} {...otherProps}>
            <PhoneInput
                smartCaret={false}
                smartCaretDisabled
                international
                defaultCountry={isPhoneTouched ? defaultCountry : undefined}
                value={value as Value}
                onChange={onChange as Props<Record<string, any>>['onChange']}
                countrySelectProps={countrySelectProps}
                inputComponent={StyledPhoneInputComponent}
                theme='auth'
                placeholder={messages.placeholderPhone}
                invalid={invalid}
                name='phone'
                onFocus={handleFocus}
                labels={phoneLabels}
                internationalIcon={InternationalIcon}
                countrySelectComponent={isPhoneTouched ? undefined : EmptyComponent}
            />

            <PhoneDropdown>
                <Dropdown
                    activator={
                        <PhoneInfoContainer>
                            <StyledInfoIcon width={18} height={18} />
                        </PhoneInfoContainer>
                    }
                    placement='top'
                    hasArrow
                    isClicking
                    width={399}
                    onOpen={handlePhoneDropdownOpen}
                >
                    <Box spacing='12'>{messages.phoneTooltip}</Box>
                </Dropdown>
            </PhoneDropdown>
        </PhoneSection>
    );
});

export default PhoneField;
